import { useNavigation } from '../../app/navigation';
import { routeChrome } from '../../app/labels';
import { NAV_ORDER } from '../../app/routes';
import { useGame } from '../../game/store';
import { useSession } from '../../state/session';
import { Icon } from '../ui/Icon';
import { ServerMark } from '../ui/ServerMark';
import styles from './NavRail.module.css';

export function NavRail() {
  const { route, navigate } = useNavigation();
  // Read once here rather than per entry: `routeChrome` is a plain function so
  // the map below stays free of hooks.
  const { wheel, naming } = useGame();
  const { theme } = useSession();

  return (
    <nav className={styles.rail} aria-label="Main navigation">
      <div className={styles.brand}>
        <span className={styles.brandMark}>
          <ServerMark size={22} />
        </span>
        <span className={styles.brandText}>
          <span className={styles.brandName}>Spoyl</span>
          <span className={styles.brandTag}>Play & earn</span>
        </span>
      </div>

      <div className={styles.list}>
        {NAV_ORDER.map((id) => {
          const definition = routeChrome(id, wheel, naming, theme);
          const isActive = route === id;
          return (
            <button
              key={id}
              type="button"
              className={`${styles.item} ${isActive ? styles.active : ''}`}
              aria-current={isActive ? 'page' : undefined}
              onClick={() => navigate(id)}
            >
              <Icon className={styles.itemIcon} name={definition.icon} size={20} />
              <span className={styles.itemLabel}>{definition.label}</span>
            </button>
          );
        })}
      </div>

      <div className={styles.footer}>
        <span className={styles.footerTitle}>Alpha version</span>
        Features are rolling out gradually.
      </div>
    </nav>
  );
}
